export default [
    {
        name: "Massa Sovada da Zélia",
        imageUrl: process.env.PUBLIC_URL + "/products/massa_sovada.png",
        varieties: ["700g", "900g"]
    },
    {
        name: "Pão",
        imageUrl: process.env.PUBLIC_URL + "/products/pao.png",
    },
    {
        name: "Papo-seco",
        imageUrl: process.env.PUBLIC_URL + "/products/papo-seco.png",
    },
    {
        name: "Pão de sementes",
        imageUrl: process.env.PUBLIC_URL + "/products/pao_sementes.png",
        varieties: ["Pequeno", "Médio", "Grande"]
    },
    {
        name: "Biscoitos",
        imageUrl: process.env.PUBLIC_URL + "/products/biscoitos.png",
        varieties: ["250g", "500g"]
    },
    {
        name: "Pão de Mistura",
        imageUrl: null
    },
    {
        name: "Pão de trigo tipo caseiro",
        imageUrl: null
    },
    // {
    //     name: "Massa Sovada com choco até 2 x 100g",
    //     imageUrl: null,
    // },
];